import React from "react";
import MaskedInput from "react-maskedinput";
import RequiredMark from "./RequiredMark";

function MaskedInput2(props) {
   
  return (
    <div className={`form-group field-${props.name}`}>
      <label className="control-label" htmlFor={props.name}>
        {props.label}
        {props.reqCols.includes(props.name) && (
           <RequiredMark/>
        )}
      </label>
      <MaskedInput 
        mask={props.mask}
        id={props.name}
        className={`form-control ${ props.errors[props.name] ? "is-invalid" : ""}`}
        name={props.name}
        value={props.value}
        maxLength={props.length}
        onChange={props.handleInputChange}
        aria-required= {props.reqCols.includes(props.name) && "true"}
        placeholder={props.placeholder}
        disabled={props.disabled?props.disabled:false}
      />

      <div className="invalid-feedback">{props.errors[props.name]}</div>
    </div>
  );
}

export default MaskedInput2;
